import yup from '@/plugins/yup'
import { i18n } from '@/plugins/i18n'

const { t } = i18n.global

const MaintenanceOpenEditSchema = yup.object({
  maintenance_type: yup
    .object()
    .required(t('errors.required', { label: t('maintenance_listing.body.table.columns.maintenance_type') })),
  priority: yup
    .object()
    .required(t('errors.required', { label: t('maintenance_listing.body.table.columns.priority') })),
  sensor: yup.object().nullable().optional(),
  company_scope: yup.object().nullable().optional(),
  description: yup
    .string()
    .required(t('errors.required', { label: t('maintenance_listing.body.table.columns.description') }))
    .min(3, t('errors.minLength', { label: t('maintenance_listing.body.table.columns.description'), min: '3' })),
  requires_shutdown: yup.boolean(),
})

export default MaintenanceOpenEditSchema
